import { z } from "zod";
import { emailSchema } from "../email";

export const passwordResetEmailFormSchema = z.object({
	email: emailSchema,
});
